import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BusinessConfig } from '../models/business-config.model';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BusinessService {

    private businessConfig: BusinessConfig;

    constructor(private http: HttpClient) {}

    public fetchConfig(publicApiUrl: string): Observable<BusinessConfig> {
        if (this.businessConfig) {
            return new Observable<BusinessConfig>(observer => observer.next(this.businessConfig));
        }
        return this.http
            .get<BusinessConfig>(`${publicApiUrl}/api/public/business/config`)
            .pipe(tap((businessConfig: BusinessConfig) => this.businessConfig = businessConfig));
    }
}
